// extracted by mini-css-extract-plugin
module.exports = {"services":"styles_services__nhHjb","pulse":"styles_pulse__ozDWj","jump":"styles_jump__cURAV","wiggle":"styles_wiggle__fRCxC"};